import { useApi } from './use-api-call';


export const useSearchUserAgentApi = () => useApi<{ 
userAgents: UserAgentDTO[];
        allowEdit: boolean; 
    }>('/user-agent/search-user-agent');

export const useGetUserAgentApi = () => useApi<{ userAgent: UserAgentDTO; allowEdit: boolean; }>('/user-agent/get-user-agent/{id}');

export const useSaveUserAgentApi = () => useApi<{ userAgent: UserAgentDTO}>('/user-agent/save-user-agent');

export const useDeleteUserAgentApi = () => useApi('/user-agent/delete-user-agent/{id}');

export interface UserAgentDTO { 
id?:number;
value:string;
os:string;
browser:string;
device:string;
brand:string;
model:string;
createdAt?:Date;
}
